/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfBoolean } from "../models/AjaxResponseOfBoolean";
import type { AjaxResponseOfEntitlementDecision } from "../models/AjaxResponseOfEntitlementDecision";
import type { AjaxResponseOfGetInventorySubdomainOutput } from "../models/AjaxResponseOfGetInventorySubdomainOutput";
import type { AjaxResponseOfListOfIntegrationDto } from "../models/AjaxResponseOfListOfIntegrationDto";
import type { AjaxResponseOfListOfPlatformVendorDto } from "../models/AjaxResponseOfListOfPlatformVendorDto";
import type { AjaxResponseOfListOfString } from "../models/AjaxResponseOfListOfString";
import type { AjaxResponseOfStockPortalCredentialDto } from "../models/AjaxResponseOfStockPortalCredentialDto";
import type { AjaxResponseOfString } from "../models/AjaxResponseOfString";
import type { AjaxResponseOfZernioConnectUrlOutput } from "../models/AjaxResponseOfZernioConnectUrlOutput";
import type { CompleteZernioConnectionInput } from "../models/CompleteZernioConnectionInput";
import type { CreateTokenModel } from "../models/CreateTokenModel";
import type { IntegrationAdmissionInput } from "../models/IntegrationAdmissionInput";
import type { IntegrationType } from "../models/IntegrationType";
import type { SetPlatformVendorCredentialInput } from "../models/SetPlatformVendorCredentialInput";
import type { StatusInput } from "../models/StatusInput";
import type { UpdateInventorySubdomainInput } from "../models/UpdateInventorySubdomainInput";
import type { ZernioConnectUrlInput } from "../models/ZernioConnectUrlInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class IntegrationAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({ id }: { id?: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/integrations",
      query: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfListOfIntegrationDto Success
   * @throws ApiError
   */
  public getAllIntegrations(): CancelablePromise<AjaxResponseOfListOfIntegrationDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/integrations",
    });
  }
  /**
   * @returns void
   * @throws ApiError
   */
  public createOrUpdate({
    requestBody,
  }: {
    requestBody?: CreateTokenModel;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/integrations",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        409: `Conflict`,
        503: `Server Error`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfGetInventorySubdomainOutput Success
   * @throws ApiError
   */
  public getCompanyAssociate(): CancelablePromise<AjaxResponseOfGetInventorySubdomainOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/integrations/company-associate",
    });
  }
  /**
   * @returns AjaxResponseOfGetInventorySubdomainOutput Success
   * @throws ApiError
   */
  public getInventorySubdomain(): CancelablePromise<AjaxResponseOfGetInventorySubdomainOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/integrations/inventory-subdomain",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public updateInventorySubdomain({
    requestBody,
  }: {
    requestBody?: UpdateInventorySubdomainInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/integrations/inventory-subdomain",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfListOfString Success
   * @throws ApiError
   */
  public getAllAvailableIntegrations(): CancelablePromise<AjaxResponseOfListOfString> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/integrations/providers",
    });
  }
  /**
   * @returns AjaxResponseOfString Success
   * @throws ApiError
   */
  public getQrCode(): CancelablePromise<AjaxResponseOfString> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/integrations/qrcode",
      errors: {
        409: `Conflict`,
        503: `Server Error`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfBoolean Success
   * @throws ApiError
   */
  public status({
    requestBody,
  }: {
    requestBody?: StatusInput;
  }): CancelablePromise<AjaxResponseOfBoolean> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/integrations/status",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfListOfPlatformVendorDto Success
   * @throws ApiError
   */
  public getAllStockPortals(): CancelablePromise<AjaxResponseOfListOfPlatformVendorDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/integrations/stock-portals",
    });
  }
  /**
   * @returns AjaxResponseOfStockPortalCredentialDto Success
   * @throws ApiError
   */
  public getStockPortalCredential({
    integrationType,
  }: {
    integrationType: IntegrationType;
  }): CancelablePromise<AjaxResponseOfStockPortalCredentialDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/integrations/stock-portals/credentials",
      query: {
        integrationType: integrationType,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public setStockPortalCredential({
    requestBody,
  }: {
    requestBody?: SetPlatformVendorCredentialInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/integrations/stock-portals/credentials",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfEntitlementDecision Success
   * @throws ApiError
   */
  public checkAdmission({
    requestBody,
  }: {
    requestBody?: IntegrationAdmissionInput;
  }): CancelablePromise<AjaxResponseOfEntitlementDecision> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/integrations/admission",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
  /**
   * @returns AjaxResponseOfZernioConnectUrlOutput Success
   * @throws ApiError
   */
  public getFacebookAdsConnectUrl({
    requestBody,
  }: {
    requestBody?: ZernioConnectUrlInput;
  }): CancelablePromise<AjaxResponseOfZernioConnectUrlOutput> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/integrations/facebook-ads/connect-url",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public completeFacebookAdsConnection({
    requestBody,
  }: {
    requestBody?: CompleteZernioConnectionInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/integrations/facebook-ads/complete",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
}
